const doc = [({"da":({"js":({"admin":({"call_lists":({"show":({"table":({"the_call_list_entity_was_deleted":"Dette nummer blev slettet"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;